import api from '../../services/ApiService'

const state = {
    stock: [],
};

const getters = {
    stock() {
        return state.stock;
    }
};

const actions = {
    fetchStock({commit}, query) {
        return api.getMatchingResult(query).then(stockResult => {
            commit('setStock', stockResult);
        });
    },
    clearStock({commit}) {
        commit('setStock', []);
    }
};

const mutations = {
    setStock(state, stock) {
        state.stock = stock;
    }    
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};